import { client } from "api";
import { Verification } from "models/Verification";

export type UploadMediaRequest = { checklistId: string; file: File };
export type UploadMediaResponse = Verification;

export const uploadMedia = (request: UploadMediaRequest) => {
  let url: string;

  if (request.file.type === "video/mp4") {
    url = `/bin/video/${request.checklistId}`;
  } else if (request.file.type === "image/jpeg") {
    url = `/bin/photo/${request.checklistId}`;
  } else {
    throw Error("Endast mp4 och jpeg filer är tillåtna");
  }

  const formData = new FormData();
  formData.append("file", request.file);

  return client.post<UploadMediaResponse>(url, formData).then((res) => res.data);
};
